import { getFunctions, httpsCallable } from 'firebase/functions';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebaseConfig';

// Inicializamos las funciones de Firebase
const functions = getFunctions();
const openpayCallable = httpsCallable(functions, 'openpayRequest');

/**
 * Función base para conectar con la Cloud Function de Firebase.
 * Sustituye la lógica anterior de axios.
 */
const openPayRequest = async (endpoint, method, data = {}) => {
  try {
    const response = await openpayCallable({
      endpoint: endpoint,
      method: method,
      data: data
    });
    
    // Firebase Functions devuelve el resultado en la propiedad .data
    return response.data;
  } catch (error) {
    console.error(`Error en petición Openpay (${endpoint}):`, error);
    // Manejo de errores detallado de Firebase
    throw error.message ? error : new Error("Error interno en el servidor de pagos");
  }
};

// --- FUNCIONES EXPORTADAS ---

export const createCustomer = async (customerData) => {
  return openPayRequest('/customers', 'POST', customerData);
};

export const refundCharge = async (orderId, data) => {
  try {
    // Buscamos la orden por ID
    const orderEndpoint = `/charges?order_id=${orderId}`;
    const orderResponse = await openPayRequest(orderEndpoint, 'GET');

    if (orderResponse && orderResponse.length > 0) {
      const chargeId = orderResponse[0].id;
      const customerId = orderResponse[0].customer_id;

      // Realizamos la devolución
      const refundEndpoint = `/customers/${customerId}/charges/${chargeId}/refund`;
      return openPayRequest(refundEndpoint, 'POST', data);
    } else {
      throw new Error(`No se encontró la orden con orderId: ${orderId}`);
    }
  } catch (error) {
    throw error;
  }
};

// CORRIGE ESTA FUNCIÓN EN TU ARCHIVO
export const addCardToCustomer = async (tokenId, customerId, deviceId) => {
  // 1. Ya recibimos el token generado en el cliente (Cards.jsx o Checkout.jsx)
  // No necesitamos llamar a /tokens aquí, porque eso enviaría datos crudos al server si lo hiciéramos vía cloud function
  
  // 2. Asociamos el token al cliente
  const data = { 
    token_id: tokenId, 
    device_session_id: deviceId 
  };

  const endpoint = `/customers/${customerId}/cards`;
  return openPayRequest(endpoint, 'POST', data);
};

export const getCardToCustomer = async (openpayId) => {
  return openPayRequest(`/customers/${openpayId}/cards`, 'GET');
};

export const getCustomerInfo = async (openpayId) => {
  return openPayRequest(`/customers/${openpayId}`, 'GET');
};

export const deleteCardFromCustomer = async (openpayId, cardId) => {
  return openPayRequest(`/customers/${openpayId}/cards/${cardId}`, 'DELETE');
};
/**
 * Garantiza que el usuario tenga perfil de pagos en Openpay. Si al registrarse falló la creación
 * (por ejemplo, sin conexión), se crea aquí la primera vez que entra a tarjetas o al checkout.
 */
export const asegurarPerfilPagos = async (userData, updateUserData) => {
  if (!userData || userData.openpayId) return userData?.openpayId || null;
  const cliente = await createCustomer({
    name: userData.username || userData.email,
    email: userData.email,
    requires_account: false,
  });
  await updateDoc(doc(db, "roles", userData.uid), { openpayId: cliente.id });
  updateUserData({ openpayId: cliente.id });
  return cliente.id;
};
